import React, { useState } from "react";
import { Button } from "../ui/button";
import { Card } from "../ui/card";
import AppointmentCalendar from "../ui/calendar";

import presentationImage from "../../images/presentation.png";

const ClientAppointmentView = ({
  onClientValidated,
  isLoading,
  token,
  canceled,
}) => {
  const [selectedDateTime, setSelectedDateTime] = useState(null);
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (!selectedDateTime || !selectedDateTime.dateTime) {
      newErrors.appointment = "Veuillez sélectionner une date et un créneau horaire";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleDateTimeSelect = (dateTimeData) => {
    setSelectedDateTime(dateTimeData);
    // Effacer l'erreur si une sélection est faite
    if (dateTimeData?.dateTime && errors.appointment) {
      setErrors({});
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      // Passer les données du rendez-vous au composant parent
      onClientValidated({
        appointment: selectedDateTime,
        referenceNumber: `RDV-${Date.now()}` // Générer un numéro de référence temporaire
      });
    }
  };

  return (
    <Card className="bg-white shadow-lg border-0 overflow-hidden m-4">
      <img
        src={presentationImage}
        alt="Groupe Lang & Associés - Expertise Automobile"
        className="w-full object-contain bg-gray-50"
      />
      <div className="p-6">
        <div className="space-y-4">
          <h2 className="text-lg font-semibold text-gray-900 text-center">
            Prise de rendez-vous
          </h2>
          {canceled && (
            <p className="text-sm text-center text-amber-800 bg-amber-50 rounded p-3">
              Votre précédent rendez-vous a été annulé, merci d'en choisir un
              nouveau.
            </p>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-3">
              <AppointmentCalendar
                selectedDateTime={selectedDateTime}
                onDateTimeSelect={handleDateTimeSelect}
                token={token}
              />
              
              {errors.appointment && (
                <p className="text-xs text-red-500">
                  {errors.appointment}
                </p>
              )}
            </div>

            <Button
              type="submit"
              disabled={isLoading || !selectedDateTime?.dateTime}
              className="w-full h-10 bg-red-600 hover:bg-red-700 disabled:bg-gray-400 text-white text-sm font-medium rounded-md transition-colors"
            >
              {isLoading ? "Confirmation..." : "Confirmer le rendez-vous"}
            </Button>
          </form>
        </div>
      </div>
    </Card>
  );
};

export default ClientAppointmentView;
